import { FixedBanner, TextLink } from '@circlefin/components'
import { usePermission } from '@circlefin/permissions/react'
import { LEGACY_APPROVAL_WORKFLOW_MUTATION } from '@services/permissions'
import { approvalSettingsSection } from '@services/sections/lib/approvalSettings'
import { ApprovalPolicyType, useApprovalPolicyQuery } from '@shared/graphql'
import Link from 'next/link'
import useTranslation from 'next-translate/useTranslation'

export const UserRemovalApprovalPolicyBanner: React.FC = () => {
  const { t } = useTranslation('settings')

  const [
    { Authorized: LegacyApprovalWorkflow, Unauthorized: NewApprovalWorkflow },
  ] = usePermission(LEGACY_APPROVAL_WORKFLOW_MUTATION)

  const { data } = useApprovalPolicyQuery({
    variables: {
      type: ApprovalPolicyType.USER_REMOVE_POLICY,
    },
    fetchPolicy: 'cache-and-network',
    onError: () => {
      // Error is ignored and failed silently
      // This banner is non-blocking and serves as informational only
      // The actual approval policy check happens server-side during user invitation
      // Users will be notified of approval requirements when the submission is processed
    },
  })

  if (data?.approvalPolicy.workflowEnabled) {
    return (
      <>
        <LegacyApprovalWorkflow>
          <FixedBanner className="mb-4">
            <FixedBanner.Description>
              {t('manageUsers.approvalSettingsInfo.banner.legacy')}
            </FixedBanner.Description>
          </FixedBanner>
        </LegacyApprovalWorkflow>

        <NewApprovalWorkflow>
          <FixedBanner>
            <FixedBanner.Title>
              {t('manageUsers.approvalSettingsInfo.banner.title')}
            </FixedBanner.Title>
            <FixedBanner.Description>
              {t('manageUsers.approvalSettingsInfo.banner.description')}
              <TextLink.Link
                anchorComponent={Link}
                href={approvalSettingsSection.route}
                size="sm"
                variant="primary"
              >
                {t('manageUsers.approvalSettingsInfo.banner.viewPolicy')}
              </TextLink.Link>
            </FixedBanner.Description>
          </FixedBanner>
        </NewApprovalWorkflow>
      </>
    )
  }

  return null
}
